export const bannerStatuses = {
  IN_PROGRESS: "IN_PROGRESS",
  COMPLETE: "COMPLETE",
  CONNECTED: "CONNECTED",
};

export const bannerStatusesForPurple = [bannerStatuses.IN_PROGRESS];
export const bannerStatusesForGreen = [
  bannerStatuses.CONNECTED,
  bannerStatuses.COMPLETE,
];

export const bannerComponentTypes = {
  AUTOPLAY_TASK: "autoplay_task",
  CALL_CAMPAIGNS: "call_campaigns",
};
